import ProtectedRoute from "ProtectedRoute"
import Card from "components/Card"
import EmptyState from "components/EmptyState"
import ToastProvider from "components/toast/ToastProvider"
import { SentryUserContext } from "components/SentryUserContext"
import Page404 from "features/layout/Page404"
import Newsletter from "features/newsletter/Newsletter"
import Offer from "features/offers/Offer"
import OfferEmptyState from "features/offers/OfferEmptyState"
import Offers from "features/offers/Offers"
import OffersPdf from "features/offersPdf/OffersPdf"
import Post from "features/offersPost/Post"
import Signature from "features/signature/Signature"
import Dashboard from "features/dashboard/Dashboard"
import AgencyUsersPage from "features/agency-users"
import AdminUsersPage from "features/admin-users"
import AdminRolesPage from "features/admin-roles"
import AdminPermissionsPage from "features/admin-permissions"
import AgenciesPage from "features/agencies"
import AgencyVisitsPage from "features/agency-visit"
import ContactsPage from "features/contact"
import DocumentsPage from "features/document"
import TravelersChecksPage from "features/travelers-check"
import TagsPage from "features/tags"
import DynamicDropdownsPage from "features/dynamic-dropdowns"
import NotificationAssignmentsPage from "features/notification-assignments"
import DocumentCategoriesPage from "features/document-categories"
import NotificationsPage from "features/notifications/components/NotificationsPage"
import type { FC } from "react"
import { Trans } from "react-i18next"
import { Route, Routes } from "react-router-dom"
import Layout from "./features/layout/Layout"

const App: FC = () => {
  return (
    <div className="App">
      <ToastProvider>
        <ProtectedRoute>
          <SentryUserContext />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="offers" element={<Offers />}>
                <Route
                  index
                  element={
                    <Card title={<Trans i18nKey="offers.title" />}>
                      <EmptyState padding="md">
                        <Trans i18nKey="offers.empty.selectOffer" />
                      </EmptyState>
                    </Card>
                  }
                />
                <Route path=":offerId" element={<Offer />}>
                  <Route index element={<OfferEmptyState />} />
                  <Route path="post" element={<Post />} />
                  <Route path="pdf" element={<OffersPdf />} />
                </Route>
              </Route>
              <Route path="newsletter" element={<Newsletter />} />
              <Route path="signature" element={<Signature />} />
              <Route path="agency-users/*" element={<AgencyUsersPage />} />
              <Route path="agency-visits/*" element={<AgencyVisitsPage />} />
              <Route path="agencies/*" element={<AgenciesPage />} />
              <Route path="contacts/*" element={<ContactsPage />} />
              <Route path="documents/*" element={<DocumentsPage />} />
              <Route path="travelers-check/*" element={<TravelersChecksPage />} />
              <Route path="tags/*" element={<TagsPage />} />
              <Route path="dynamic-dropdowns/*" element={<DynamicDropdownsPage />} />
              <Route path="notification-assignments/*" element={<NotificationAssignmentsPage />} />
              <Route path="document-categories/*" element={<DocumentCategoriesPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="admin/users/*" element={<AdminUsersPage />} />
              <Route path="admin/roles/*" element={<AdminRolesPage />} />
              <Route path="admin/permissions/*" element={<AdminPermissionsPage />} />
              <Route path="*" element={<Page404 />} />
            </Route>
          </Routes>
        </ProtectedRoute>
      </ToastProvider>
    </div>
  )
}

export default App
